import { render, staticRenderFns } from "./cuestionario-snp.vue?vue&type=template&id=6cb541f1&"
import script from "./cuestionario-snp.component.ts?vue&type=script&lang=ts&"
export * from "./cuestionario-snp.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports